// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2615) return "static/chunks/2615-8b952dd4fba75368.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5075":"a402999cced8a3e8","6278":"d5c49048b7873526","8572":"aecfae6ffe6c08b4"}[chunkId] + ".js";
};